export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
  NONE = '',
}

export enum CellType {
  PERMISSIONS = 'permissions',
  ACCOUNTING = 'accounting',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
}

export interface ITableConfig {
  rowConfigs: ITableRowConfig[];
  extraActionsFlexValue?: number;
}

export interface ITableRowConfig {
  header: string;
  flexValue: number;
  isSortable?: boolean;
  alternativeSortField?: string; // If provided, it will be used as sorting field instead of header value
  cellType?: CellType;
  icon?: boolean;
  bigCell?: boolean;
  isLocked?: boolean;
  isUppercase?: boolean;
}
